import { showWarn } from "@/modules/error/errorStream.ts";
import { Suspense, type ReactNode } from "react";

export function DoNotSuspendHere() {
    showWarn(
        "SUSPENSE: Activated in a component whose children should not suspend.\nFix: Find the suspenders and wrap them in <Suspense>.",
    );
    return import.meta.env.DEV ? (
        <div className="size-100% min-h-200px bg-error text-white font-size-heading">Do not suspend</div>
    ) : null;
}

export function NoSuspense({ children }: { children: ReactNode }) {
    return (
        <Suspense name="NoSuspense" fallback={<DoNotSuspendHere />}>
            {children}
        </Suspense>
    );
}
